import { isMobile, scrollState, setMobileHeight } from "@/utils";

export const headerMobileMixin = {
    data() {
        return {
            showMobileMenu: false,
        };
    },
    watch: {
        $route() {
            if (isMobile()) {
                scrollState.enable();
                this.showMobileMenu = false;
            }
        },
        city: {
            handler() {
                if (isMobile()) {
                    scrollState.enable();
                    this.showMobileMenu = false;
                }
            },
        },
    },
    mounted() {
        if (isMobile(992)) {
            setMobileHeight();
        }
    },
    methods: {
        scrollToHeader() {
            if (this.$refs.scrollHeader) {
                this.$refs.scrollHeader.scrollIntoView(true);
            }
        },
        checkForScrolling() {
            const heightToBanner = 30;
            return window.pageYOffset < heightToBanner;
        },
        openMobileMenu() {
            if (this.isTopBanner && this.checkForScrolling()) {
                this.scrollToHeader();
            }
            this.showMobileMenu = !this.showMobileMenu;
            if (this.showMobileMenu) {
                scrollState.disable();
                if (isMobile(992)) {
                    setMobileHeight();
                }
            } else {
                scrollState.enable();
            }
        },
        closeMobileMenu() {
            this.showMobileMenu = false;
            scrollState.enable();
        },
        onClickAnchor(hash) {
            this.closeMobileMenu();
            setTimeout(() => {
                const element = document.querySelector(`#${hash}`);
                if (element) {
                    window.scrollTo({
                        top: element.getBoundingClientRect().top + window.scrollY - 65,
                        behavior: "smooth",
                    });
                }
            }, 100);
        },
    },
};
